import { Const } from '~/constants/Const.constant';
import { WeatherModule } from '~/models/modules/netatmo/WeatherModule.model';

export class NAModule4 extends WeatherModule {

    battery_levels = {
        full : Const.NABatteryLevelIndoorModule.INDOOR_BATTERY_LEVEL_0,
        high : Const.NABatteryLevelIndoorModule.INDOOR_BATTERY_LEVEL_1,
        medium : Const.NABatteryLevelIndoorModule.INDOOR_BATTERY_LEVEL_2,
        low : Const.NABatteryLevelIndoorModule.INDOOR_BATTERY_LEVEL_3,
    };
    loadData(data: any) {
        super.loadData(data);
        this.loadOffset(data.offset);
    }

    get column() {
        return 'right';
    }

}
